var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"book-container",attrs:{"href":_vm.href,"target":"_blank","rel":"noreferrer noopener"}},[_c('div',{staticClass:"book"},[_c('img',{attrs:{"alt":"暂无封面","id":"bookImg","src":_vm.src,"loading":"lazy"},on:{"error":_vm.imgError}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }